import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PartGroupDto } from 'src/app/auto-generated-server-dtos/claim/repairs/part-group-dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetAllPartsService {

  constructor(private httpClient: HttpClient) { }

  
  public GetAllParts(): Observable<PartGroupDto[]> {
    return this.httpClient.get<PartGroupDto[]>(`${environment.apiServer}/Adjuster/GetAllParts`);
  }
}
